import de from './langs/de.js';
import en from './langs/en.js';

export const translations = {
    de,
    en
};

export default translations; 